import React from 'react';
import SocialLinks from '../components/SocialLinks';
import OurTeam from './Ourteam';
import { IMAGE_BASE } from '../constants/site';
import '../Content/firstpage.css';
import './About.css';

const About = () => (
  <div className="wrapper-news about-page">
    <div className="grid-container">
      <div className="super-grid-left">
        <div className="grid-box-1 grid-color">
          <div className="About">
            <h4>About us</h4>
            <div className="grid-box-2 grid-color-about">
              <div className="grid-2-row-about">
                <div className="grid-2-col-about">
                  <h3>Welcome to Vientiane Traffic</h3>
                  <p>
                    At Vientiane Traffic, we are a leading enterprise in Vientiane Capital, Lao
                    People&apos;s Democratic Republic. Founded by Mr. Khamphone Keomanydeth, we
                    have built more than a decade of trusted service in road safety, signage, and
                    industrial protection.
                  </p>
                </div>
                <div className="grid-2-col">
                  <img src={`${IMAGE_BASE}/Picture19.png`} alt="Vientiane Traffic office" />
                </div>
              </div>

              <div className="grid-2-row-about">
                <div className="grid-2-col">
                  <img src={`${IMAGE_BASE}/Picture16.png`} alt="Road safety project" />
                </div>
                <div className="grid-2-col-about">
                  <h3>International reach</h3>
                  <p>
                    Vientiane Traffic serves clients across Laos and international markets with
                    solutions that meet global standards in road safety, signage, and industrial
                    protection.
                  </p>
                  <h3>Quality assurance</h3>
                  <p>
                    We use modern equipment and strict quality control on every project. Our focus
                    on precision and reliability has earned long-term partnerships with public and
                    private sector clients.
                  </p>
                </div>
              </div>

              <div className="grid-2-col">
                <img src={`${IMAGE_BASE}/Picture2.png`} alt="Vientiane Traffic operations" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="super-grid-right">
        <div className="grid-box-9 grid-color">
          <div className="heading">
            <h4>Follow us</h4>
            <div className="line"></div>
          </div>
          <SocialLinks />
        </div>

        <div className="grid-box-10 grid-color-ab">
          <div className="heading-about">
            <h4>Vision</h4>
          </div>

          <div className="grid-10-img">
            <img src={`${IMAGE_BASE}/img41.jpg`} alt="Road safety vision" />
          </div>
          <div className="grid-10-item">
            <div className="grid-6-item-content">
              <h5>
                Road safety is the foundation of our work. Through precision marking, innovative
                signage, and advanced lighting solutions, we create environments where every journey
                is secure.
              </h5>
              <h6>Vientiane Traffic</h6>
            </div>
          </div>

          <div className="grid-10-item">
            <div className="grid-10-item-img-about">
              <img src={`${IMAGE_BASE}/img25.jpg`} alt="Project showcase" />
            </div>
            <div className="grid-6-item-content">
              <div className="grid-10-item-img-about">
                <img src={`${IMAGE_BASE}/img24.jpg`} alt="Signage installation" />
              </div>
            </div>
          </div>

          <div className="heading-about">
            <h3>Create a safe environment at your location.</h3>
          </div>

          <div className="grid-10-img">
            <img src={`${IMAGE_BASE}/img40.jpg`} alt="Safety environment" />
          </div>
          <div className="grid-10-item">
            <div className="grid-6-item-content">
              <h5>
                Thank you for considering Vientiane Traffic as your partner in road safety and
                signage. We look forward to supporting the success and safety of your projects.
              </h5>
              <h6>Vientiane Traffic</h6>
            </div>
          </div>

          <div className="grid-10-item">
            <div className="grid-10-item-img-about">
              <img src={`${IMAGE_BASE}/Picture14.png`} alt="Team at work" />
            </div>
            <div className="grid-6-item-content">
              <div className="grid-10-item-img-about">
                <img src={`${IMAGE_BASE}/Picture7.png`} alt="Completed project" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <OurTeam />
  </div>
);

export default About;
